<app-warehouse-product-add
  (productCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
></app-warehouse-product-add>
